module.exports = __webpack_public_path__ + "img/scenario-custom.e3da3f0.svg";